<template>
  <header>
    <a href="http://liveperformance.com.au" target="_blank" title="Live Performance Australia" class="lpalogo">Live
      Performance Australia</a>

    <div class="row clearfix">
      <page-title text="2025 Live Performance Attendance and Revenue Report"></page-title>
      <NavMenu/>
    </div>
    <div class="fullbg">
      <p class="caption">Photo: <em>Kylie Minogue - Tension Tour</em>, Frontier Touring, Photo Credit: Eric Melvin</p>
      <div class="overlay"></div>
    </div>
  </header>
</template>

<script>
import PageTitle from '@/components/atoms/PageTitle'

export default {
  components: {
    PageTitle
  }
}
</script>

<style lang="scss" scoped="scoped">
header div.fullbg {
  background-image: url("~@/assets/img/2025/1-Front-Cover-Kylie-Minogue_Tension-Tour-Feb-2025_Melvin_2.jpg");
}
</style>
